import React from 'react';
import Stack from '@mui/material/Stack';
import { Radius, Spacing } from '../../constants';
export const CardWrapper = ({ children }) => {
    return (React.createElement(Stack, { flexGrow: 1, justifyContent: {
            mobile: 'flex-start',
            tablet: 'center',
        }, alignItems: "center" },
        React.createElement(Stack, { maxWidth: 470, width: "100%", border: {
                mobile: 'none',
                tablet: 'solid 1px var(--mui-palette-lightBorder-default)',
            }, borderRadius: {
                mobile: 'none',
                tablet: Radius.large,
            }, boxShadow: {
                mobile: 'none',
                tablet: '0px 2px 24px 10px rgba(0, 0, 0, 0.03)',
            }, paddingX: {
                mobile: Spacing.large,
                tablet: Spacing.xxlarge,
            }, paddingY: {
                mobile: 0,
                tablet: Spacing.xxlarge * 2,
            } }, children)));
};
